export const messages = {
  has_started:
    "Type in the email address and wait for the account suggestions to make sure that the user information exist.",
  has_not_started:
    "Make sure that the GSuite and Workday accounts have been created. Type in the email address and wait for the account suggestions to ensure that the user information exist.",
  email_has_changed: "Don’t forget to update the Login ID if it’s incorrect.",
  form_has_errors:
    "Oops! There are missing information. Please ensure that you have updated all fields.",
  user_id_not_found: `Sorry, I can’t find your records. You may click [HERE](https://docs.google.com/forms/d/e/1FAIpQLSdzRcCIJwKDEJBtXObCTVkj1WaHJRNpvC0xpcWRHLnFxS8ElA/viewform?usp=sf_link) to request for registration. Rest assured that this will be attended with urgency.`,
  // user_id_not_found: `Sorry, I can’t find your records. You may click
  // [HERE](/feedback)
  // to report this
  // feedback. Rest assured that this will be attended with urgency.`,
  // duplicated_user: "You cannot add duplicate users.",
};
